export const getIsLoading = state => state.login.isLoading;

export const getError = state => state.login.error;

export const getUserId = state => state.login.userId;
